export default __webpack_public_path__ + "static/media/DSC_7428.2190e2fd.jpg";